/* eslint-disable no-unused-vars */

import React, { useEffect, useState, useImperativeHandle } from 'react';

import Icon from '@components/icon-component';
import useWindowDimensions from '@hooks/useWindowDimensions';

import style from './style.module.scss';

const MarkerIcon = (
  { count, iconName, selectedIconName, selectedSiteId, siteIdCurrent, clickEvent },
  ref
) => {
  const [selected, setSelected] = useState(false);

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (selectedSiteId && siteIdCurrent) {
      if (selectedSiteId !== siteIdCurrent && selected) {
        setSelected(false);
      }
      if (selectedSiteId === siteIdCurrent && !selected) {
        setSelected(true);
      }
    } else {
      setSelected(false);
    }
  }, [selectedSiteId, siteIdCurrent]);

  const clearSelectedIcon = () => {
    setSelected(false);
  };

  useImperativeHandle(
    ref,
    () => ({
      clearSelectedIcon
    }),
    [setSelected]
  );

  return (
    <div
      className={style.hello}
      onClick={() => {
        width > 1024 && setSelected(true);
      }}
      onTouchStart={() => {
        width < 1024 && setSelected(true);
      }}
    >
      {count ? <span>{count}</span> : <></>}
      <Icon name={selected ? selectedIconName : iconName} />
    </div>
  );
};

export default React.forwardRef(MarkerIcon);
